import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TablePagination from '@mui/material/TablePagination';
import PropTypes from 'prop-types';


/**
 * @param {TablePaginationWithPageSelector.propTypes} props
 * @return {JSX.Element}
 */
export function TablePaginationWithPageSelector(props) {
    const {page, pageNum, rowsPerPage, handleChangeRowsPerPage,
        handleChangePage, handlePageSelection, count, rowsPerPageOptions} = props;
    const textColor = props.textColor ? {color: props.textColor} : {};

    return (
        <div className={'list-of-pr-pagination'} translate={'no'} style={textColor}>
            <label>Page:</label>
            <Select
                sx={{
                    'fontSize': 14,
                    'boxShadow': 'none',
                    '.MuiOutlinedInput-notchedOutline': {border: 0},
                    '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline':
                        {
                            border: 0,
                        },
                    '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
                        {
                            border: 0,
                        },
                    ...textColor,
                }}
                value={(pageNum === undefined || pageNum === null || pageNum.length === 0) ? '' : page+1}
                onChange={(event) => handlePageSelection(event.target.value - 1)}
                displayEmpty
                inputProps={{'aria-label': 'Without label'}}
            >
                {pageNum.map((pages) => {
                    return <MenuItem key={pages.value} sx={{fontSize: 14}} value={pages.value}> {pages.label} </MenuItem>;
                })}
            </Select>
            <TablePagination
                rowsPerPageOptions={rowsPerPageOptions}
                component={'div'}
                count={count}
                page={(page > 0 && count < page * rowsPerPage) ? 0 : page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{color: textColor || 'inherit'}}
            />
        </div>
    );
}


TablePaginationWithPageSelector.propTypes = {
    page: PropTypes.number,
    pageNum: PropTypes.array,
    rowsPerPageOptions: PropTypes.array,
    count: PropTypes.number,
    rowsPerPage: PropTypes.number,
    handleChangeRowsPerPage: PropTypes.func,
    handleChangePage: PropTypes.func,
    handlePageSelection: PropTypes.func,
    textColor: PropTypes.string,
};
